import { schema } from 'normalizr';

export const eventSchema = new schema.Entity('events');



// WEBPACK FOOTER //
// ./src/store/schema.js